module.exports = function () {

    if ($('.logos-module').length === 0) {
        return;
    }    
        
    $('.logos-module__load-more-button').click(function () {        
        var $container = $(this).closest('.logos-module__container');        
        var $logosContainer = $container.find('.logos-module__logos-container');       
        var $nextHiddenLogos = $logosContainer.find('.logos-module__logo--mobile-hidden').slice(0, 4);        
        $nextHiddenLogos.removeClass('logos-module__logo--mobile-hidden');
        var $remainingHiddenLogos = $logosContainer.find('.logos-module__logo--mobile-hidden');        
        if (!$remainingHiddenLogos.length) {            
            $(this).addClass('logos-module__load-more-button--hidden');
        }
    });    
};